
export default {
  allUnits: [],
  allGroupUnits:[],
  loading: true
}
